import { getHttpClient } from '../../axiosInstance'

const base = 'vendor/users/v1'

export const load = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/user`

  const response = await apiClient.get(url)
  return response.data
}

export const update = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/form`

  const response = await apiClient.put(url, form)
  return response.data
}

export const createEventNotAvailable = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/event`

  const response = await apiClient.post(url, form)
  return response.data
  // actionPostPattern("vendor/users/v1/event", form);
}

export const dismissEvent = async (eventId) => {
  const apiClient = getHttpClient()
  const url = `${base}/dismiss-event/${eventId}`

  const response = await apiClient.put(url, {})
  return response.data
  // actionPutPattern("vendor/users/v1/dismiss-event/" + eventId, {});
}

export const rejectPrices = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/reject-prices`

  const response = await apiClient.put(url, {})
  return response.data

  /*
  actionPutPattern(
    "vendor/users/v1/reject-prices",
    {},
    onSuccess({
        message: "Update",
        description: "The price review was canceled.",
    })
  );
  */
}

export const cancelPaymentMethod = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/cancel-payment-method`

  const response = await apiClient.put(url, {})
  return response.data
}

export const updatePaymentMethod = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/payment-method`

  const response = await apiClient.post(url, form)
  return response.data
}

/*
export const deletePaymentMethod = async (paymentId) => {
  const apiClient = getHttpClient()
  const url = `${base}/payment-method/${paymentId}`

  const response = await apiClient.delete(url)
  return response.data
} */
